module.exports = __webpack_public_path__ + "img/icon-yandex-graph.a11dbd5c.svg";